var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLabelTorquePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8017_3088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2829 10.3739L18.5501 7.47403C17.8927 6.96211 17.0709 6.70811 16.2392 6.75982C15.4076 6.81154 14.6235 7.1654 14.0345 7.75482L13.7422 8.04807",
    stroke: "#6921C4",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.71875 5.89467C0.71875 4.52217 1.26397 3.20589 2.23447 2.23539C3.20497 1.26488 4.52125 0.719666 5.89375 0.719666",
    stroke: "#6921C4",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 6.2959C3.3125 5.47215 3.63973 4.68214 4.22222 4.09966C4.80469 3.51717 5.59471 3.18994 6.41846 3.18994",
    stroke: "#6921C4",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04489 8.94037L3.34243 9.64283C3.24626 9.73885 3.16996 9.85289 3.11791 9.97844C3.06586 10.104 3.03906 10.2386 3.03906 10.3745C3.03906 10.5104 3.06586 10.6451 3.11791 10.7706C3.16996 10.8961 3.24626 11.0102 3.34243 11.1062L12.231 19.9957C12.3271 20.0919 12.4412 20.1682 12.5669 20.2203C12.6925 20.2724 12.8271 20.2992 12.9631 20.2992C13.0991 20.2992 13.2338 20.2724 13.3594 20.2203C13.485 20.1682 13.5992 20.0919 13.6953 19.9957L14.7677 18.908",
    stroke: "#FF6019",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4425 16.2908L18.9653 14.7297C19.0615 14.6336 19.1378 14.5196 19.1898 14.394C19.2419 14.2685 19.2687 14.134 19.2687 13.998C19.2687 13.8621 19.2419 13.7275 19.1898 13.602C19.1378 13.4764 19.0615 13.3624 18.9653 13.2663L10.0729 4.37682C9.97679 4.28061 9.86265 4.2043 9.73701 4.15223C9.61137 4.10016 9.47674 4.07336 9.34075 4.07336C9.20475 4.07336 9.0701 4.10016 8.94447 4.15223C8.81884 4.2043 8.7047 4.28061 8.60858 4.37682L8.15625 4.83011",
    stroke: "#FF6019",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9219 14.628L17.6215 11.9284",
    stroke: "#FF6019",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8906 18.6569L12.7603 16.7863",
    stroke: "#FF6019",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2805 22.2803L17.3518 20.6377C16.5083 20.3564 15.7418 19.8826 15.1131 19.2538L13.0652 17.2059C12.7828 16.9236 12.6154 16.5463 12.5957 16.1473C12.5761 15.7484 12.7054 15.3565 12.9586 15.0477C13.2119 14.7389 13.5709 14.5353 13.9659 14.4765C14.3609 14.4177 14.7636 14.5079 15.0959 14.7295L18.6571 17.1033",
    stroke: "#6921C4",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41798 12.8234C9.75607 12.8786 10.1025 12.8513 10.4278 12.7441C10.7531 12.6368 11.0478 12.4527 11.2867 12.2071C11.6569 11.9332 11.9069 11.5265 11.984 11.0725C12.0611 10.6183 11.9597 10.152 11.7007 9.77106C11.3339 9.49285 10.8735 9.3674 10.4162 9.42099C9.95885 9.47458 9.54001 9.70311 9.24739 10.0586C8.9543 10.414 8.53514 10.6424 8.07758 10.6959C7.62 10.7496 7.15943 10.6242 6.79214 10.3461C6.53369 9.96503 6.43247 9.49881 6.50962 9.04485C6.58676 8.5909 6.83631 8.18432 7.20614 7.91C7.44397 7.66251 7.73812 7.47617 8.06351 7.36688C8.38889 7.25758 8.73587 7.22856 9.07489 7.2823",
    stroke: "#FF6019",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2891 12.2072L11.9685 12.9231",
    stroke: "#FF6019",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 7.18658L7.21071 7.90342",
    stroke: "#FF6019",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8017_3088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLabelTorquePay);
export default __webpack_public_path__ + "static/media/WhiteLabelTorquePay.0546b336.svg";
export { ForwardRef as ReactComponent };